import { Instance, types } from 'mobx-state-tree'

const InputData = types.model('InputData', {
  id: types.optional(types.string, ''),
  labelName: types.optional(types.string, ''),
  labelType: types.union(types.string, types.number),
  labelString: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  usage: types.optional(types.string, ''),
  errorMessage: types.optional(types.string, ''),
  displayOrder: types.optional(types.number, 0),
  validationPattern: types.optional(types.string, ''),
  info: types.optional(types.string, ''),
})

const PayLater = types.model('PayLater', {
  id: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  accountNumber: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  isPopular: types.optional(types.boolean, false),
  rank: types.optional(types.number, 0),
  inputData: types.optional(types.array(InputData), []),
  paymentType: types.optional(types.string, 'PayLater'),
  isSelected: types.optional(types.boolean, false),
  type: types.optional(types.string, ''),
  key: types.optional(types.string, ''),
  value: types.optional(types.string, ''),
  description: types.optional(types.string, ''),
})

export type PayLaterType = Instance<typeof PayLater>
export { PayLater }
